import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components
import logoImage from '../../../images/logo_text_bubble.svg';
import Image from '../atoms/Image';
import TextHeadingThree from '../atoms/TextHeadingThree';
import TextParagraph from '../atoms/TextParagraph';

//Returning the component
class EmailVerify extends Component {
	render() {
		return (
			<div className="emailVerify">
				<div className="emailVerify__container">
				<a href="/"><Image alt="Frankie Logo" classType="emailVerify__logo" src={logoImage} /></a>
					<div className="emailVerify__message">
						<TextHeadingThree classType="emailVerify__heading" text={this.props.heading} />
						<TextParagraph classType="" text={this.props.paragraphText} />
					</div>
				</div>
			</div>
		)
	}
}

export default EmailVerify;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/EmailVerify.jsx